import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';


export function* initConnectivitySaga(action) {
  //console.log('init connectivity go')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
  yield put(actions.initConnectivityStart());
  try {
    let response = {};
        response = yield axios.post(
          '/connectivity',
          { rMac:rMac,
            bToken: token,
            sessionToken:sessionToken }
        ).then(res=>{
          // console.log('is res', res.data)
          let parsedData = JSON.parse(res.data.data)
          // console.log('connectivity parsed data', parsedData)
          // sessionStorage.setItem("vendorModel", parsedData.model);
          return parsedData

        })
    yield //console.log('gonna set conn', response.status)
    yield put(actions.setConnectivity(response.status));
  } catch (error) {
    yield put(actions.fetchConnectivityFailed());
  }
} else {
  //console.log('NO TOKEN')
 }

}

export function* initGetSpectrumReadyStatusSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    yield put(actions.initGetSpectrumStatusStart());
    try {
        const response = yield axios.post(
        '/specSuspendStatus',
        {
          rMac: rMac,
          bToken: token,
          sessionToken: sessionToken
        }
        );

      if (response.data.status === 500) {
        yield put(actions.getSpectrumStatusFailed(response.data.error))
        return;
      }
      yield put(actions.setSpectrumStatus(response.data))
    } catch (error) {
      yield put(actions.getSpectrumStatusFailed(error.message))
    }
  }

}

export function* moveInSaga(action) {
 const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  if (sessionToken) {
    yield put(actions.initConnectivityStart());
    try {
      let response = {};
          response = yield axios.post(
            '/moveIn',
            { rMac:rMac,
              bToken: token,
              sessionToken:sessionToken }
          ).then(res=>{
            //console.log('is res', res.data)
            let parsedData = JSON.parse(res.data.data)
            //console.log('MoveIn parsed data', parsedData)
            // sessionStorage.setItem("vendorModel", parsedData.model);
            return parsedData

          })
      yield //console.log('gonna set conn', response.status)
      yield put(actions.setConnectivity(response.status));
      yield put(actions.changeSettingsSuccess());
    } catch (error) {
      yield put(actions.changeSettingsFailed());
    }
} else {
  //console.log('NO TOKEN')
 }


}


export function* moveOutSaga(action) {
  //console.log('moveout saga')
 const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  if (sessionToken) {
    yield put(actions.initConnectivityStart());
    try {
      let response = {};
          response = yield axios.post(
            '/moveOut',
            { rMac:rMac,
              bToken: token,
              sessionToken:sessionToken }
          ).then(res=>{
            //console.log('is res', res.data)
            let parsedData = JSON.parse(res.data.data)
            //console.log('moveout parsed data', parsedData)
            // sessionStorage.setItem("vendorModel", parsedData.model);
            return parsedData

          })
      yield //console.log('gonna set conn', response.status)
      yield put(actions.setConnectivity(response.status));
      yield put(actions.changeSettingsSuccess())
      let timerStart = Date.now()
      yield put(actions.restarting(timerStart));
      yield put(actions.checkWan(rMac,token, sessionToken, packageJson.firstCheckWanWait, timerStart));
    } catch (error) {
      yield put(actions.changeSettingsFailed());
    }
} else {
  //console.log('NO TOKEN')
 }


}

